export default "__VITE_ASSET__CPJz9orM__"